import { render, staticRenderFns } from "./ygabn.vue?vue&type=template&id=03655639&scoped=true"
import script from "./ygabn.vue?vue&type=script&lang=ts"
export * from "./ygabn.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ygabn.vue?vue&type=style&index=0&id=03655639&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "03655639",
  "85af8866"
  
)

export default component.exports